(() => {
  const root = document.documentElement;
  if (root.dataset.suedlisImageGuard === 'true') return;
  root.dataset.suedlisImageGuard = 'true';

  const graphics = 'img, picture, svg, canvas, [role="img"]';
  const editable = 'input, textarea, select, [contenteditable]:not([contenteditable="false"])';

  const preventImageAction = (event) => {
    const target = event.target?.nodeType === 1 ? event.target : event.target?.parentElement;
    if (!target?.closest || target.closest(editable)) return;
    if (target.closest(graphics)) event.preventDefault();
  };

  // Delegation also covers gallery, search and configurator images added later.
  document.addEventListener('contextmenu', preventImageAction, { capture: true, passive: false });
  document.addEventListener('dragstart', preventImageAction, { capture: true, passive: false });
})();
